import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "Carousel 3-Up",
    description: "Carousel with 3 items in each slide.",
};
